/**
 * Action for Fetch Scheduled maintenance details
 */
export enum getScheduledMaintenance {
  FETCH_SCHEDULED_MAINTENANCE_REQUEST = 'FETCH_SCHEDULED_MAINTENANCE_REQUEST'
}
